import { API } from '../env';
import { readCookie } from './common';
//let userId = readCookie('copyrightuserId') || window['copyrightuserId'];
(function(para) {
	let p = para.sdk_url,
		n = para.name,
		w = window,
		d = document,
		s = 'script',
		x = null,
		y = null;
	w['sensorsDataAnalytic201505'] = n;
	w[n] =
		w[n] ||
		function(a) {
			return function() {
				(w[n]._q = w[n]._q || []).push([a, arguments]);
			};
		};
	let ifs = [
		'track',
		'quick',
		'register',
		'registerPage',
		'registerOnce',
		'clearAllRegister',
		'trackSignup',
		'trackAbtest',
		'setProfile',
		'setOnceProfile',
		'appendProfile',
		'incrementProfile',
		'deleteProfile',
		'unsetProfile',
		'identify',
		'login',
		'logout',
		'trackLink',
		'clearAllRegister'
	];
	for (let i = 0; i < ifs.length; i++) {
		w[n][ifs[i]] = w[n].call(null, ifs[i]);
	}
	if (!w[n]._t) {
		x = d.createElement(s);
		y = d.getElementsByTagName(s)[0];
		x.async = 1;
		x.src = p;
		w[n].para = para;
		y.parentNode.insertBefore(x, y);
	}
})({
	sdk_url: '//gallerytemplate.vphotos.cn/js/sensorsdata.min.js',
	heatmap_url: '//gallerytemplate.vphotos.cn/js/heatmap.min.js',
	web_url: '//sensors.vphotos.cn/',
	show_log: true,
	name: 'sensors',
	server_url: API.SA_SERVER_URL,
	is_track_single_page: true,
	heatmap: {
		//是否开启点击图，默认 default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭
		clickmap: 'default',
		//是否开启触达注意力图，默认 not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启
		scroll_notice_map: 'not_collect'
	}
});
(() => {
	let sensors = window['sensors'];
	sensors.registerPage({
		vp_platform: 'CopyrightH5',
		$app_version: 'v1.0.0',
		gh5_host: window.location.host
	});
	console.log('sensors.....', API.SA_SERVER_URL);
	// sensors.quick('autoTrack'); //神策系统必须是 1.4 最新版及以上
	sensors.quick('autoTrackSinglePage');
	login();
})();
/**
 * 活动名称	touh5_activity_name	string
 * 投图页面名称	touh5_page_name	string
 * 专题名称	touh5_subject_name	string	专题的名字
 * 标签名称	touh5_tag_name	string	图片的所属标签
 * 登录用户ID touh5_user_id
 */
export function login() {
	let sensors = window['sensors'];
	let userId = readCookie('copyrightuserId') || window['copyrightuserId'];
	if (userId) {
		sensors &&
			sensors.login(userId, function() {
				//回调函数的使用需要 SDK 版本大于等于 1.14.8
				// console.log('sensors 登录成功', userId);
			});
	}
}
export function _track({ trackName = 'defaultName', payload = {} }) {
	let userId = readCookie('copyrightuserId') || window['copyrightuserId'];
	// let copyright_nickname = readCookie('copyright_nickname');
	// let copyright_iscontract = readCookie('copyright_iscontract');
	// let copyright_instName = readCookie('copyright_instName');
	// let copyright_showState = readCookie('copyright_showState');
	let sensors = window['sensors'];
	// console.log('sensors', sensors);
	sensors &&
		sensors.track(trackName, {
			...payload,
			// touh5_page_name: '2',
			// touh5_subject_name: '3',
			// touh5_tag_name: '4',
			vp_userId: userId,
			//DATETIME 类型，可以直接传 new Date() 或者 传 yyyy-MM-dd HH:mm:ss.SSS / yyyy-MM-dd HH:mm:ss 格式的字符串。
			vp_viewTime: new Date()
		});
}
